import { Actions, createNamespace } from "../../../../flux/Actions";
import { Division } from "../../../../models";

const ns = createNamespace('EDIT_PERSON');
export const names = {
    SET_DIVISION: ns('SET_DIVISION'),
    SET_DIVISION_ITEMS: ns('SET_DIVISION_ITEMS'),
    SET_FIRST_NAME: ns('SET_FIRST_NAME'),
    SET_LAST_NAME: ns('SET_LAST_NAME'),
    SET_USER_NAME: ns('SET_USER_NAME'),
    SET_PASSWORD: ns('SET_PASSWORD'),
    SET_PASSWORD_CONFIRMATION: ns('SET_PASSWORD_CONFIRMATION'),
    SET_ADMIN_FLAG: ns('SET_ADMIN_FLAG'),
}

export class EditCreatePersonActions extends Actions
{
    setDivision = (divisionId: number) => this.dispatch(names.SET_DIVISION, divisionId);
    setDivisionItems = (divisions: Division[]) => this.dispatch(names.SET_DIVISION_ITEMS, divisions);
    setFirstName = (value: string) => this.dispatch(names.SET_FIRST_NAME, value);
    setLastName = (value: string) => this.dispatch(names.SET_LAST_NAME, value);
    setUserName = (value: string) => this.dispatch(names.SET_USER_NAME, value);
    setAdminFlag = (value: boolean) => this.dispatch(names.SET_ADMIN_FLAG, value);
    setPassword = (value: string) => this.dispatch(names.SET_PASSWORD, value);
    setPasswordConfirmation = (value: string) => this.dispatch(names.SET_PASSWORD_CONFIRMATION, value);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/EditCreatePersonActions.ts